/*
 * [WEBSITE] "You may also like" (Randy 2026-10-20 (au) item 8: "approved as designed"; docs/website-as-plans-2026-10-20.md).
 * Everything the shopper did stays in THEIR browser (localStorage "na_recent": the last 12 books they opened, newest first; no name,
 * no email, nothing sent). For each book for sale they have not opened:
 *   likeness(c, v) = 0.35 x characters in common (shared / all of the two) + 0.20 x same publisher + 0.15 x same era
 *                    + 0.15 x grade closeness (1 - |difference| / 2, never below 0) + 0.15 x price band (same 1, next 0.5, else 0)
 *   personal       = the recency-weighted average likeness to the books they opened (newest weight 1, then x 0.8 each)
 *   popularity     = log(1 + eBay watchers) / log(1 + the most watchers of any book for sale)
 *   eBay weight    = max(20%, 70% x 0.85^n), n = books they opened
 *   score          = eBay weight x popularity + (1 - eBay weight) x personal; the top 8, ties = newest listed first.
 * Books come from the store's own index (assets/na-search.js, /collections/all?view=na-index). Pure part exported for tests.
 */
(function (root) {
  'use strict';
  var W = { ch: 0.35, pu: 0.20, er: 0.15, gr: 0.15, pb: 0.15 };
  var band = function (cents) { var p = Number(cents) / 100; return p < 50 ? 0 : p < 100 ? 1 : p < 250 ? 2 : p < 500 ? 3 : 4; };

  /** How much book c is like book v (pure, 0..1). Books: { ch: [characters], pu, er, gr, p (cents) }. */
  function likeness(c, v) {
    var a = c.ch || [], b = v.ch || [];
    var inter = a.filter(function (x) { return b.indexOf(x) !== -1; }).length;
    var uni = a.concat(b.filter(function (x) { return a.indexOf(x) === -1; })).length;
    var ch = uni ? inter / uni : 0;
    var pu = c.pu && c.pu === v.pu ? 1 : 0;
    var er = c.er && c.er === v.er ? 1 : 0;
    // a raw book's grade is words ("VF/NM"), not a number: no grade likeness (else NaN breaks the sort)
    var gn = Number(c.gr), vn = Number(v.gr);
    var gr = c.gr && v.gr && isFinite(gn) && isFinite(vn) ? Math.max(0, 1 - Math.abs(gn - vn) / 2) : 0;
    var d = Math.abs(band(c.p) - band(v.p));
    var pb = d === 0 ? 1 : d === 1 ? 0.5 : 0;
    return W.ch * ch + W.pu * pu + W.er * er + W.gr * gr + W.pb * pb;
  }

  /** The eBay share (pure): 70% with nothing opened, x0.85 per book opened, never below 20%. */
  function ebayWeight(n) { return Math.max(0.2, 0.7 * Math.pow(0.85, Math.max(0, n))); }

  /** The top books (pure). books = the index; viewed = the opened books, newest first; exclude = handles not to show. */
  function rank(books, viewed, exclude, limit) {
    exclude = exclude || [];
    var seen = {};
    var key = function (b) { return b.h || b.u; };
    viewed.forEach(function (v) { seen[key(v)] = 1; });
    exclude.forEach(function (k) { seen[k] = 1; });
    var forSale = books.filter(function (b) { return b.a !== false && !seen[key(b)]; });
    var maxW = forSale.reduce(function (m, b) { return Math.max(m, Number(b.wa) || 0); }, 0);
    var w = ebayWeight(viewed.length);
    var weights = viewed.map(function (v, i) { return Math.pow(0.8, i); });
    var wsum = weights.reduce(function (s, x) { return s + x; }, 0);
    var out = forSale.map(function (b, i) {
      var personal = 0;
      viewed.forEach(function (v, k) { personal += weights[k] * likeness(b, v); });
      personal = wsum ? personal / wsum : 0;
      var pop = maxW ? Math.log(1 + (Number(b.wa) || 0)) / Math.log(1 + maxW) : 0;
      return { b: b, score: w * pop + (1 - w) * personal, personal: personal, pop: pop, i: i };
    });
    out.sort(function (x, y) { return y.score - x.score || String(y.b.la || '').localeCompare(String(x.b.la || '')) || x.i - y.i; });
    return out.slice(0, limit || 8);
  }

  /**
   * Round 2 item 4 (Randy 2026-10-21): the order of the books in a category for THIS shopper (pure). Same score as rank(), over
   * the books on the page (`list`), popularity scaled by the whole index (`books`). A book they opened is scored on its likeness
   * to the OTHER books they opened (it is not pushed up just for being opened). Nothing opened = eBay watchers first, ties newest
   * listed first = the store's default order. Returns the handles, best first.
   */
  function order(books, list, viewed) {
    var key = function (b) { return b.h || b.u; };
    var maxW = books.reduce(function (m, b) { return b.a === false ? m : Math.max(m, Number(b.wa) || 0); }, 0);
    var w = ebayWeight(viewed.length);
    var out = list.map(function (b, i) {
      var personal = 0, wsum = 0;
      viewed.forEach(function (v, k) {
        if (key(v) === key(b)) return;
        var x = Math.pow(0.8, k);
        personal += x * likeness(b, v);
        wsum += x;
      });
      personal = wsum ? personal / wsum : 0;
      var pop = maxW ? Math.log(1 + (Number(b.wa) || 0)) / Math.log(1 + maxW) : 0;
      return { h: key(b), score: w * pop + (1 - w) * personal, la: b.la, i: i };
    });
    out.sort(function (x, y) { return y.score - x.score || String(y.la || '').localeCompare(String(x.la || '')) || x.i - y.i; });
    return out.map(function (x) { return x.h; });
  }

  var api = { likeness: likeness, ebayWeight: ebayWeight, rank: rank, order: order, band: band, W: W };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.NARecos = api;
})(typeof window !== 'undefined' ? window : this);
